<!-- 首页 -->
<template>
  <div :class="isNeedCloseIn390 ? 'home1' : 'home'">
    <headerNav :isindex="true"  :canclick="false" :header-title="webName" :show-sort="showSort" @yinYang="yinYang" />
    <div class="content">
      <div class="banner">
        <van-swipe
          class="my-swipe"
          :show-indicators="true"
          indicator-color="white"
          :swiper-data="m_thumb"
          :autoplay="3000"
        >
          <van-swipe-item  v-for="(item,index) in m_thumb" :key="index">
            <a :href="item.url">
              <img :src="item.h5_pic_img" alt="">
            </a>
          </van-swipe-item>
        </van-swipe>
      </div>
      <!-- 中间导航 -->
      <div class="nav_tab clearfix">
        <ul :class="nav_tab.length<5?'flex_box':''">
          <li v-for="(item,index) in nav_tab" :key="index" class="item_tab" @click="clickTabItem(item)">
            <img :src="item.thumb" alt="">
            <p>{{ item.name }}</p>
          </li>
        </ul>
      </div>
      <!-- 直播专区 -->
      <div v-show="zblist.length>0" class="zhibo">
        <p class="my_curriculum_border"></p>
        <b style="font-size: 14px">直播专区</b>
        <div class="zhiboleft" @click="zhibo">
          <span style="font-size: 14px">全部直播&nbsp;></span>
        </div>
      </div>
      <div v-show="zblist.length>0" class="zongjie">
        <div class="xiao_zbs">
          <ul class="main_title" :class="zblist.length===1?'main_title_width_dengyu_1':'main_title_width'">
            <li v-for="(val, key) in zblist" :key="key" class="morelive_item" :class="zblist.length===1 ? 'morelive_item_width_dengyu_1': zblist.length-1===key ? 'morelive_item_width_last':'morelive_item_width'">
              <a href="javascript:void(0);" class="live_item" :class="zblist.length===1 ? 'morelive_item_width_dengyu_1':'morelive_item_width'" @click="go_live(val)">
                <div class="live_left">
                  <img onerror="javascript:this.src='https://newoss.zhulong.com/tfs/noavatar_big.gif'" :src="val.logo">
                  <span class="teacher_name">{{ val.teacher_name }}</span>
                </div>
                <div class="live_right">
                  <div class="div_content">
                    <p class="more-title">{{ val.title }}</p>
                    <p class="sub_title">{{ val.lesson_name }}</p>
                  </div>
                  <p v-if="parseInt(val.status)===1" class="p">
                    <img src="@/assets/play.gif">
                    <span class="sp_iv" style="color: #ee2e2e">正在直播</span>
                  </p>
                  <p v-else class="more-yugao">
                    <img src="@/assets/zbyg.png" class="imgsnz">
                    <span class="sp_iv">直播预告&nbsp;&nbsp;{{ val.startDateTime }}</span>
                  </p>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="webName == '全部'" class="allLesson">
        <div v-for="(item,index) in list" v-show="item.lesson_list&&item.lesson_list.length > 0" :key="index" class="item">
          <div class="flex clearfix">
            <p class="my_curriculum_border"></p>
            <b class="tit_le">{{ item.title }}</b>
            <!-- <div class="moreLesson" @click="goSubtotal(item)">
              <span style="font-size: 14px">查看更多&nbsp;></span>
            </div> -->
          </div>
          <div class="list">
            <ul class="course-list clearfix">
              <li v-for="(li,i) in item.lesson_list" :key="i" @click="goToDetails(li.lesson_id)">
                <img class="course-img" :src="li.thumb">
                <p class="course-name">
                  {{ li.lesson_name }}
                </p>
                <div class="course-bot flex_box">
                  <span class="bot-left">
                    <img src="@/assets/image/peps.png">{{ li.buy_count }}人学习
                  </span>
                  <span class="bot-right">
                    <img src="@/assets/image/flower.png">{{ li.comment_rate }}%好评
                  </span>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="item.showMore" @click="go_more(item)" style="textAlign:center;">查看更多</div>
        </div>
      </div>
      
      <div v-if="webName != '全部'" class="lesson_list">
        <div v-if="lesson.length" class="lesson_bottom">
          <div class="flex">
            <p class="my_curriculum_border"></p>
            <b class="tit_le">{{webName}}</b>
          </div>
          <ul>
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getMoreDatas">
              <div class="lessonListBox">
                <li v-for="(item,index) in lesson" :key="index" class="item_lesson" @click="goToCourse(item.lesson_id)">
                  <img :src="item.thumb" alt="" class="l_img">
                  <div class="r_msg">
                    <p class="title">{{ item.lesson_name }}</p>
                    <div class="cate clearfix">
                      <div class="l">
                        <img src="@/assets/image/peps.png" alt="">
                        <span>{{ item.buy_count }}人学习</span>
                      </div>
                      <div class="r">
                        <img src="@/assets/image/flower.png" alt="">
                        <span>{{ item.comment_rate }}%好评</span>
                      </div>
                    </div>
                  </div>
                </li>
              </div>
            </van-list>
            <div class="kong"></div>
          </ul>
        </div>
      </div>
    </div>
    <footerNav active="/"></footerNav>
  </div>
</template>

<script>
import { promotion, getMenuList, getLiveList, getLessonList } from '@/api/lesson.js'
import { getCategoryLesson, getRowSeo } from '@/api/edu.js'
import { mapActions } from 'vuex'
import tool from '@/utils/tools.js'
// import {mapMutations} from 'vuex'
import Cookies from 'js-cookie'
export default {
  name: '',
  inject: ['reload'],
  data() {
    return {
      loading: false,
      dataItem: [
        {
          imgSrc: 'https://newoss.zhulong.com/tfs/pic/v1/tfs/T1ZxW_BKK_1RCvBVdK.jpg'
        }
      ],
      webSpecialty_id: Cookies.get('webSpecialty_id') || '',
      webMainId: Cookies.get('webMainId') || '',
      webName: Cookies.get('webName') || '',
      webType: Cookies.get('webType') || '',
      lesson: [],
      showSort: Cookies.get('webName') ? '0' : '1',
      name: '',
      m_thumb: [],
      zblist: [],
      nav_tab: [],
      isShow: true,
      finished: false,
      count: 0,
      page: 1,
      pageSize: 10,
      list:[],
      lessonIds:[],
      // 其他机构嵌套他们app的，Eg：390，需要给个关闭按钮,调用他们自己的方法
      isNeedCloseIn390: false
    }
  },
  computed: {},

  created() {
    const need = tool.checkLocationAgencyIdInApp('390')
    if(need){
      this.isNeedCloseIn390 = true
    }
    this.getSeo()
    this.getbanner()
    this.topH5Fun()
    // this.pageInit()
    this.getData()
  },

  mounted() {
    // alert(this.webType, 'webType')
    console.log(this.webType, 'webType')
    this.getLive()
    // this.getIndexLists(2)
    console.log(this.webMainId,'webMainId')
  },
  methods: {
    getSeo() {
      var params = {
        type: 2
      }
      getRowSeo(params).then(res => {
        // console.log(res.result, 'res.resultres.result')
        // 设置title标题
        const my_title = document.getElementsByTagName('title')[0]
        my_title.innerHTML = res.result.result.title
        // 设置关键词
        const my_keys = document.getElementsByName('keywords')[0]
        my_keys.content = res.result.result.words
        // 设置描述
        const my_description = document.getElementsByName('description')[0]
        my_description.content = res.result.result.description
      })
    },
    go_more(item){
      console.log(item)
      item.pageNum ++ 
       var info = {
          category_id: item.id,
          is_vip: -1,
          pageNum:item.pageNum,
          pageSize:4
        }
        getCategoryLesson(info).then((res)=>{
          if(res.errNo==0){
            if(res.result.lesson_list.length==4){
              item.showMore = true
            }else{
              item.showMore = false
            }
            item.lesson_list = [...item.lesson_list,...res.result.lesson_list]
          }
        })
    },
    go_live(item) {
      this.$router.push({
        path: '/live',
        query: {
          lesson_id: item.lesson_id,
          live_id: item.id
        }
      })
    },
    goToDetails(id){
      this.$router.push({
        path:'/home',
        query:{
          lesson_id:id
        }
      })
    },
    getMoreDatas() {
      this.onLoad()
    },
    beforeOnLoad() {
      // 注意顺序
      this.lesson = []
      this.finished = false
      this.page = this.getCurrentPage()
      this.onLoad()
    },
    getCurrentPage() {
      const count = this.lesson.length
      const limit = this.pageSize
      const page = Math.ceil((count / limit)) + 1 // 默认1
      return page
    },
    onLoad() {
      this.loading = true
      this.page = this.getCurrentPage()
      console.log('page is ' + this.page)
      const params = {
        type: 0,//this.webType,//0代表获取所有的课程
        level: this.webSpecialty_id ? 2 : 1,
        category_id: this.webSpecialty_id ? this.webSpecialty_id : this.webMainId,
        pageNum: this.page,
        pageSize: this.pageSize
      }
      getLessonList(params).then(res => {
        this.loading = false
        const result = res.result ? res.result : {}
        const list = result.list ? result.list : []
        this.count = result.count
        if (this.page === 1) {
          this.lesson = list
        } else {
          this.lesson = this.lesson.concat(list)
        }
        // 是否 有值显示
        if (this.lesson.length > 0) {
          this.isShow = true
        } else {
          this.isShow = false
        }
        // 是否结束
        if (list.length < this.pageSize) {
          this.finished = true
          console.log('没有更多了')
        } else {
          this.finished = false
        }
      })
    },
    zhibo() {
      if (tool.isInApp()) {
        var path = window.location.href + 'liveList'
        if (process.env.NODE_ENV === 'production') {
          path = window.location.href  + '/liveList'
        }
        this.unitAppOpenUrl(path)
      } else {
        this.$router.push('/liveList')
      }
    },
    // 跳转一级分类列表页
    goSubtotal(item){
      this.$router.push({
        path:'/subtotal',
        query:{
          id:item.id
        }
      })
    },
    // 金刚区
    topH5Fun() {
      var info = {
        position: 4,
        type: 2 // 1 pc  2 h5
      }
      getMenuList(info).then((res) => {
        if (res.errNo == 0) {
          const list = res.result
          this.nav_tab = list
        }
      })
    },
    // 直播专区
    getLive() {
      var info = {
        category_id: this.category_id||''
      }
      getLiveList(info).then((res) => {
        if (res.errNo == 0) {
          this.zblist = res.result.list
        }
      })
    },
    // 点击金刚区
    clickTabItem(item) {
      if (item && item.url) {
        const path = item.url
        this.$router.push({ path: path })
      }
    },
    ...mapActions({
      'actionActionName': 'home/actionActionName',
      'actionActionMainId': 'home/actionActionMainId',
      'actionActionSpecialty_id': 'home/actionActionSpecialty_id',
      'actionActionWebType': 'home/actionActionWebType'
    }),
    yinYang(value) {
      this.page=1
      this.lesson=[]
      this.webName = value.className
      this.webSpecialty_id = value.secondId
      this.webMainId = value.firstId
      this.webType = value.type
      // this.actionActionName({ 'webName': this.webName })
      // this.actionActionName({ 'webMainId': this.webMainId })
      // this.actionActionName({ 'webSpecialty_id': this.webSpecialty_id })
      this.getData()
    },
    // 新首页分类数据
    getData(){
      // if(this.webMainId.includes(',')){
        
      // }
      // console.log(this.lessonIds,'this.lessonIdsthis.lessonIds')
      if (this.webName == '全部') {
        this.lessonIds = this.webMainId.split(',')
        this.getLesson()
      }else{
        // this.getOneList()
        this.onLoad()
      }
    },
    // 获取全部数据
    async getLesson() {
      this.list=[]
      for (var i = 0; i < this.lessonIds.length; i++) {
        var info = {
          category_id: this.lessonIds[i],
          is_vip: -1,
          pageNum:1,
          pageSize:4
        }
        await getCategoryLesson(info).then(res => {
          // console.log(res)
          res.result.pageNum = 1
          if(res.result.lesson_list.length==4){
            res.result.showMore = true
          }else{
            res.result.showMore = false
          }
          this.list.push(res.result)
        })
      }
    },
    getbanner() {
      promotion().then(res => {
        this.m_thumb = res.result
      })
    },
    goToCourse(id) {
      this.$router.push({ path: '/home', query: { lesson_id: id }})
    }
  }
}

</script>
<style lang='scss' scoped>
.home{
  padding: 0 30px;
  padding-bottom: 100px;
  padding-top: 80px;
  height: 100%;
  overflow: hidden;
  background-color: #f7f7f7;
}
.home1{
  padding: 0 30px;
  padding-bottom: 100px;
  padding-top: 160px;
  height: 100%;
  overflow: hidden;
  background-color: #f7f7f7;
}
.banner{
    height: 378px;
    width: 100%;
    margin-bottom: 20px;    
    .van-swipe{
      height: 100%;
    }
    img{
      width: 100%;
      height: 100%;
    }
  }
  .nav_tab{
    border-radius: 12px;
    background-color: #fff;
    ul{
      float: left;
      width: 100%;
      display: flex;
      overflow-x: scroll;
      .item_tab{
        float: left;
        width: 18%;
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 30px 0;
        flex-shrink: 0;
        img{
          width: 88px;
          height: 88px;
        }
        p{
          margin-top: 15px;
          font-size: 28px;
        }
      }
    }
  }
  .lesson_list{
    margin-top: 20px;
    .lesson_top{
      padding: 0 30px;
      .title{
        font-size: 28px;
        font-weight: bold;
      }
      .img{
        width: 100%;
        height: 390px;
        border-radius: 10px;
        margin-top: 23px;
      }
      .cate{
        display: flex;
        align-items: center;
        height: 80px;
        .r{
          margin-left: 10px;
        }
        .l,.r{
          display: flex;
          align-items: center;
          color: #909090;
          img{
            margin-right: 5px;
          }
        }
      }
    }
    .lesson_bottom{
      // margin-top: 10px;
      ul {
        margin-top: 10px;
      }
      .lessonListBox{
        // padding: 28px;
        display: flex;
        flex-wrap: wrap;
        background-color: #fff;
        padding: 30px 0 0;
        border-radius: 12px;
        margin-bottom: 20px;
      }
      .item_lesson{
        // width: 337px;
        // margin-right:20px;
        // margin-bottom:40px;
        // width: 50%;
        display: flex;
        flex-direction: column;
        margin-left: 30px;
        width: calc(50% - 45px);
        margin-bottom: 40px;
        .l_img{
          border-radius: 10px;
          width: 100%;
          height: 240px;
          overflow: hidden;
        }
        .r_msg{
          flex:1;
          height: 150px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .title{
            font-weight: 600;
            white-space:nowrap;        // 强制一行显示
            overflow:hidden;          // 超出隐藏
            text-overflow:ellipsis;   // 省略号
            color: #333333;
            margin: 10px 0 20px;
          }
          .cate{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .r{
              margin-left: 10px;
            }
            .l,.r{
              display: flex;
              align-items: center;
              color: #909090;
              img{
                margin-right: 5px;
              }
            }
          }
        }
      }
      .item_lesson:nth-child(2n){
        margin-right: 0;
      }
    }
  }
/deep/ .nut-swiper{
  height: 378px;
}
.content{
  height: calc(100vh - 180px);
  // padding-top:80px;
  overflow: scroll;
  -webkit-overflow-scrolling:touch;
  // position:fixed;
  // top: 80px;
  // left: 0;
  width: 100%;
}
.kong{
  height: 160px;
}

.my_curriculum_border {
  display: inline-block;
  width: 5px;
  height: 34px;
  background: #db403b;
  margin: 0px 0 0 0px;
}
.favorite_border {
  display: inline-block;
  width: 5px;
  height: 34px;
  background: #db403b;
}
.zhiboleft {
  position: absolute;
  right: 5px;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(153, 153, 153);
  span {
    display: inline-block;
    margin-right: 20px;
  }
}
.zhibo {
  height: 40px;
  margin: 20px auto 15px;
  display: flex;
  align-items: center;
  position: relative;
  b {
    margin-left: 10px;
  }
}
.zongjie {
  padding: 0 30px;
  // margin: 0 30px;
  width: calc(100% - 60px);
  height: 280px;
  // background: blue;
  overflow-x: hidden;
  overflow-y: hidden;
  white-space: nowrap;
  border-radius: 12px;
  background-color: #fff;
}
.xiao_zbs {
  // padding-left: 30px;
  height: 100%;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-top: 10px;
  overflow-x: scroll;
}
.main_title_width_dengyu_1 {
  width: calc(100% - 23px);
  // padding-bottom: 34px;
}
.main_title_width {
  padding: 0 34px 23px 0;
}
.main_title {
  display: flex;
  height: 100%;

  align-items: center;
  flex-shrink: 0;
  .morelive_item_width_dengyu_1 {
    width: 99%;
  }
  .morelive_item_width {
    width: 480px;
    margin-right: 34px;
  }
  .morelive_item_width_last {
    width: 480px;
  }
  ul:last-child {
    margin-left: 34px;
  }

  .morelive_item {
    height: 220px;
    float: left;
    position: relative;
    border-radius: 10px;
    background: #f7f7f7;
    border: 1px solid #e6e6e6;
    .live_item {
      height: 100%;
      display: flex;
      .live_left {
        padding-top: 5px;
        padding-bottom: 40px;
        margin-top: 10px;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-direction: column;
        .teacher_name {
          font-size: 24px;
          color: #999999;
        }
        & > img {
          width: 79px;
          height: 79px;
          // display: inline-block;
          overflow: hidden;
          border-radius: 50%;
          margin: 10px 23px 3px 23px;
          border: 0 solid #e6e6e6;
        }
      }
      .live_right {
        height: 184px;
        padding-top: 28px;
        padding-bottom: 10px;
        width: 66%;
        display: flex;
        position: relative;
        flex-direction: column;
        .div_content {
          width: 100%;
        }
        .p {
          display: flex;
          position: absolute;
          bottom: 0px;
          margin-bottom: 20px;
          align-items: center;
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
    }

    p {
      & > img {
        width: 16px;
        vertical-align: sub;
        margin-right: 6px;
      }
    }

    .more-title {
      // height: 70px;
      // padding-top: 23px;
      font-size: 28px;
      color: #333333;
      white-space: pre-wrap;
      // 移动端多行失效
      /*! autoprefixer: off */
	    /* autoprefixer: on */
      word-break: break-all;/*追加这一行代码*/
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;

      &:hover {
        color: #ee2e2e;
      }
    }
    .sub_title {
      font-size: 26px;
      color: #999999;
      display: -webkit-box;
      margin-top: 12px;
      white-space: pre-wrap;
      // 移动端多行失效
      /*! autoprefixer: off */
	    /* autoprefixer: on */
      word-break: break-all;/*追加这一行代码*/
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .more-yugao {
      position: absolute;
      bottom: 0px;
      color: #adadad;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      font-size: 24px;
      img {
        width: 32px;
        height: 32px;
      }
    }
  }
}
.flex{
  display: flex;
  align-items: center;
}
.flex_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tit_le{
  font-size:28px;
  margin-left:20px;
}
.allLesson{
  margin-top: 25px;
  .my_curriculum_border{
    margin-left: 0;
  }
  .item{
    margin-bottom:20px;
  }
  .flex{
    margin-bottom: 20px;
    position:relative;
  }
  .moreLesson{
    position: absolute;
    right: 5px;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(153, 153, 153);
    span {
      display: inline-block;
      // margin-right: 20px;
    }
  }
}
.course-list{
  display: flex;
  flex-wrap: wrap;
  background-color: #fff;
  padding: 30px 0 0;
  border-radius: 12px;
  margin-bottom: 20px;
  li{
    display: block;
    margin-left: 30px;
    width: calc(50% - 45px);
    margin-bottom: 40px;
    // height: 448px;
  }
  
  .course-img {
    border-radius: 10px;
    width: 100%;
    height: 240px;
    overflow: hidden;
  }
}
.course-list li:nth-child(2n){
  margin-right: 0;
}
.course-name{
  font-weight: 600;
  white-space:nowrap;        // 强制一行显示
	overflow:hidden;          // 超出隐藏
	text-overflow:ellipsis;   // 省略号
  color: #333333;
  margin: 10px 0 20px;
}
.course-bot{
  color: #909090;
  img{
    width: 30px;
    height: 30px;
    margin-right: 4px;
    vertical-align: text-top;
  }
}

// .course-item{
//   width: 33.33%;
//   margin-bottom: 20px;
//   margin-left: 10px;
//   margin-right: 10px;
//   border-radius: 10px;
//   background-color: #fff;
//   box-shadow: 0px 2px 4px rg
// }
.my-swipe{
  border-radius: 12px;
  /deep/.van-swipe__indicator{
    width: 30px;
    height: 6px;
    border-radius: 12px;
  }
}
// 隐藏滚动条
::-webkit-scrollbar {
  display: none;
}
</style>
